import React, { useState } from 'react';
import { AdminGamic } from './types';
import RemoteFile from '@/helper/RemoteFile';

interface Props { gamic: AdminGamic }

const GamicConsoleReport: React.FC<Props> = ({ gamic }) => {
  const [logs, setLogs] = useState<string[]>([]);

  const push = (msg: string) =>
    setLogs(prev => [...prev, `[${new Date().toLocaleTimeString()}] ${msg}`]);

  return (
    <div className="grid grid-cols-2 gap-6  w-full">
      {/* Left – preview */}
      <div className="bg-[#F5F5F5] rounded-lg p-[32px]">
        <h4 className="text-[24px] font-[700] mb-2">Live Preview</h4>
        <div className="flex items-center justify-center h-[600px] p-4">
          <RemoteFile
            keyPath={gamic.file}
            key={gamic.title}
            className="h-full w-full"
            onLog={push}                    
          />
        </div>
      </div>
      {/* Right – console */}
      <div className="bg-[#F5F5F5] rounded-lg p-[32px]">
        <h4 className="text-[24px] font-[700] mb-2">Console Report</h4>
        <div className="h-[600px] overflow-y-auto scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent rounded-lg p-4 text-xs font-mono">
          {logs.map((l, i) => <div key={i}>{l}</div>)}
        </div>
      </div>
    </div>
  );
};

export default GamicConsoleReport;
